import OverviewRows from '@/components/ezuro/workschedule/components/OverviewRows.vue';
import ScheduleTable from '@/components/ezuro/mixins/ScheduleTable.js';

export default {
  name: 'TableOverview',
  props: {
    departmentId: {
      type: Number
    },
    divisionId: {
      type: Number
    },
    filterData: {
      type: Object
    },
    scheduleData: {
      type: Object
    },
    showAllRows: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  mixins: [ScheduleTable],
  components: {
    OverviewRows
  },
  data: function () {
    return {
      hiddenTeams: [],
      isElementReady: false
    }
  },
  computed: {
    weekday_names () {
      return this.$t('general.datestr.weekdays.short');
    },
    layoutSettings () {
      return this.$store.state.hr.ezLayoutSettings;
    },
    mainColumnsCount () {
      return (this.layoutSettings && this.layoutSettings.showTotals) ? 12 : 3;
    }
  },
  methods: {
    editRecord: function (record) {
      this.$emit('editRecord', record);
    },
    addRecord: function (record) {
      this.$emit('editRecord', record);
    },
    filter () {
      this.$emit('filter');
    },
    toggleTeam: function (id) {
      const index = this.hiddenTeams.indexOf(id);

      if (index !== -1) {
        this.hiddenTeams.splice(index, 1);
      } else {
        this.hiddenTeams.push(id);
      }
    }
  },
  mounted () {
    this.isElementReady = true;
  },
  unmounted () {
    this.isElementReady = false;
  }
}
